<template>
    <div align="center">
        <v-divider
  :thickness="6"
  class="border-opacity-100"
  color="#FFB762"
  style="width: 50%;"
></v-divider>
    </div>
  
</template>

<script>
export default {

}
</script>

<style>

</style>